import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetAdmin = async () => {
  /**
   * input: null
   * output: admin object
   * description: fetches admin data as object
   */

  try {
    const clientsDocument = await doc(
      db,
      "clients",
      getLocalStorageItem("bid")
    );
    const { uid } = await (await getDoc(clientsDocument)).data();

    /** Getting users document */
    const usersDocument = await doc(db, "users", uid);
    const usersSnapshot = await getDoc(usersDocument);
    const admin = { id: usersSnapshot.id, ...usersSnapshot.data() };

    return admin;
  } catch (error) {
    console.log(error);
    // error.name === "FirebaseError"
    //   ? window.location.replace("/internal/server/error")
    //   : window.location.replace("/connection/timeout");
  }
};

export default GetAdmin;
